import api from '../api'
export default {
  setTitle() {
    let titleStr = sessionStorage.getItem('titleStr')
    window.document.title = titleStr
  },
  setThemeColor() {
    // 主题色
    let root = document.querySelector(':root')
    root.style.setProperty('--themeColor', sessionStorage.getItem('themeColor'));
  },
  getUrlParam() {
    let url = window.location.href
    url = unescape(url)
    if (url.indexOf('?') < 0) {
      return ''
    }
    let obj = {}
    let str = url.split('?')[1]
    if (str.indexOf('&') >= 0) {
      let paramArr = str.split('&')
      for (let i = 0; i < paramArr.length; i++) {
        let arr = paramArr[i].split('=')
        obj[arr[0]] = arr[1]
      }
    } else {
      let strArr = str.split('=')
      obj[strArr[0]] = strArr[1]
    }
    return obj
  },
  themeStyleUniform() {
    document.getElementsByClassName('el-button--primary')[0].style.background =
      '#17202e'
    document.getElementsByClassName(
      'el-button--primary'
    )[0].style.border = `1px solid #17202e`
  },

  // 验证 身份证
  regCId(idCard) {
    var val = idCard;
    // var tipStr = '请输入15位或者18位的合法身份证号！';
    var isT = validateIdCard(val);
    return isT;
    function validateIdCard(idCard) {
      var vcity = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外'
      };
      if(idCard === '') {
        return false;
      }
      if(isCardNo(idCard) === false) {
        return false;
      }
      if(checkProvince(idCard, vcity) === false) {
        return false;
      }
      if(checkBirthday(idCard) === false) {
        return false;
      }
      if(checkParity(idCard) === false) {
        return false;
      }
      return true;
    }
    function isCardNo(card) {
      var reg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
      if(reg.test(card) === false) {
        return false;
      }
      return true;
    }
    function checkProvince(card, vcity) {
      var province = card.substr(0, 2);
      if(vcity[province] == undefined) {
        return false;
      }
      return true;
    }
    function checkBirthday(card) {
      var len = card.length;
      if(len == '15') {
        var re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
        var arr_data = card.match(re_fifteen);
        var year = arr_data[2];
        var month = arr_data[3];
        var day = arr_data[4];
        var birthday = new Date('19' + year + '/' + month + '/' + day);
        return verifyBirthday('19' + year, month, day, birthday);
      }
      if(len == '18') {
        var re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X|x)$/;
        var arr_data = card.match(re_eighteen);
        var year = arr_data[2];
        var month = arr_data[3];
        var day = arr_data[4];
        var birthday = new Date(year + '/' + month + '/' + day);
        return verifyBirthday(year, month, day, birthday);
      }
      return false;
    }
    function verifyBirthday(year, month, day, birthday) {
      var now = new Date();
      var now_year = now.getFullYear();
      if(birthday.getFullYear() == year && (birthday.getMonth() + 1) == month && birthday.getDate() == day) {
        var time = now_year - year;
        if(time >= 0 && time <= 100) {
          return true;
        }
        return false;
      }
      return false;
    }
    function checkParity(card) {
      card = changeFivteenToEighteen(card);
      var len = card.length;
      if(len == '18') {
        var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        var cardTemp = 0;
        var i;
        var valnum;
        for (i = 0; i < 17; i ++) {
          cardTemp += card.substr(i, 1) * arrInt[i];
        }
        valnum = arrCh[cardTemp % 11];
        if (valnum == card.substr(17, 1).toLocaleUpperCase()) {
          return true;
        }
        return false;
      }
      return false;
    }
    function changeFivteenToEighteen(card) {
      if(card.length == '15') {
        var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        var cardTemp = 0;
        var i;
        card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6);
        for(i = 0; i < 17; i ++) {
          cardTemp += card.substr(i, 1) * arrInt[i];
        }
        card += arrCh[cardTemp % 11];
        return card;
      }
      return card;
    }
  },
  realNameVerification(that, name, idCard) {
    // if (sessionStorage.getItem('isConsistencyIdCard') && sessionStorage.getItem('isConsistencyIdCard') === 'true') {
      // 如果开启实名验证
      return new Promise((resolve, reject) => {
        api.GetValidationToken().then(restoken => {
          if (restoken.data.Status === 'OK') {
            api.CheckValidation({
              Name: name,
              IDNum: idCard,
              Code: sessionStorage.getItem('consistencyIdCardAppCode'),
              APPKey: restoken.data.AppTokenKey,
              AppValue: restoken.data.AppTokenValue
            }).then(valres => {
              if (valres.data.Status === 'OK') {
                // if(valres.data.result === 'false') {
                //   that.$alert('您输入的姓名与身份证号不一致');
                //   this.themeStyleUniform();
                //   that.loading = false;
                // }
                resolve(valres.data.result)
              } else {
                that.$alert(valres.data.Msg, '错误信息', {
                  confirmButtonText: '确定',
                  closeOnClickModal: true,
                  type: 'error'
                });
                this.themeStyleUniform();
                that.loading = false;
              }
            })
          } else {
            that.$alert('token获取失败，请重新获取', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                api.GetValidationToken().then(restoken => {
                  if (restoken.data.Status === 'OK') {
                    api.CheckValidation({
                      Name: name,
                      IDNum: idCard,
                      Code: sessionStorage.getItem('consistencyIdCardAppCode'),
                      APPKey: restoken.data.AppTokenKey,
                      AppValue: restoken.data.AppTokenValue
                    }).then(valres => {
                      if(valres.data.Status === 'OK') {
                        // if(valres.data.result === 'false') {
                        //   that.$alert('您输入的姓名与身份证号不一致');
                        //   this.themeStyleUniform();
                        //   that.loading = false;
                        // }
                        resolve(valres.data.result)
                      } else {
                        that.$alert(valres.data.Msg, '错误信息', {
                          confirmButtonText: '确定',
                          closeOnClickModal: true,
                          type: 'error'
                        });
                        this.themeStyleUniform();
                        that.loading = false;
                      }
                    })
                  } else {
                    that.$alert(restoken.data.Msg, '错误信息', {
                      confirmButtonText: '确定',
                      closeOnClickModal: true,
                      type: 'error'
                    });
                    this.themeStyleUniform();
                    that.loading = false;
                  }
                })
              }
            });
            this.themeStyleUniform();
          }
        })
      })
    // } else {
    //   return 'true'
    // }
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js